import React, { useState, useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  PDFViewer,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { Button, Typography, Divider } from "antd";
import { DownloadOutlined, ArrowLeftOutlined } from "@ant-design/icons"; // Iconos de Ant Design
import { useMediaQuery } from "react-responsive"; // Necesitarás instalar: npm install react-responsive
import config from "../../config";

const baseUrl = config.baseUrl;
const { Title } = Typography;

// Estilos para el PDF
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    paddingTop: 10,
    paddingRight: 60,
    paddingLeft: 60,
    paddingBottom: 50,
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  content: {
    flexGrow: 1,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontSize: 12,
    marginTop: 5,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
  },
  title_respuesta: {
    fontSize: 12,
    marginTop: 7,
    textAlign: "justify",
    marginBottom: 5,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    textDecoration: "underline",
  },
  textareaLabel: {
    fontSize: 12,
    lineHeight: 1.5,
    textAlign: "justify",
    marginBottom: 12,
    marginTop: 12,
    fontFamily: "Helvetica",
  },
  header: {
    marginBottom: 20,
  },
  headerTable: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    marginBottom: 20,
  },
  banner: {
    width: "100%",
    height: 40,
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  tableInfo: {
    fontSize: 12,
    fontFamily: "Helvetica",
    textAlign: "left",
  },
  tableTitle: {
    fontWeight: "bold",
  },
  // Para la última celda de la fila quitamos el borde derecho
  lastCell: {
    borderRightWidth: 0,
  },
  logoColumn: {
    width: "75%",
    alignItems: "center",
  },
  infoColumn: {
    width: "220px",
    borderWidth: 1,
    borderColor: "#000",
  },
  codeRow: {
    padding: 3,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  codeText: {
    fontSize: 9,
    fontFamily: "Helvetica",
    textAlign: "center",
  },
  dateVersionRow: {
    flexDirection: "row",
    height: "25px",
  },
  dateCell: {
    width: "55%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  versionCell: {
    width: "45%",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  text: {
    fontSize: 10,
    fontFamily: "Helvetica",
    textAlign: "left",
  },
  footer: {
    position: "absolute",
    bottom: 20, // Coloca el footer al final de la página
    left: 20,
    right: 20,
    textAlign: "center",
    fontSize: 12,
  },
  logo: {
    justifyContent: "center",
    alignItems: "center",
  },
  date: {
    fontSize: 12,
    textAlign: "left",
    fontWeight: "bold",
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#052956", // Color de fondo verde claro para el encabezado
    fontWeight: "bold",
    color: "#ffffff"
  },
  tableCol: {
    width: "33%", // Cada columna ocupa un tercio del ancho
    padding: 5,
    textAlign: "center",
    borderLeftWidth: 1,
    borderRightWidth: 1,
  },
  tableCell: {
    fontSize: 12,
    padding: 5,
  },
  questionSection: {
    marginTop: 7,
  },
  questionText: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 5,
  },
  checkbox: {
    width: 15,
    height: 15,
    borderWidth: 1,
    borderColor: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 10, // Añadir separación entre la casilla y el texto
  },
  checkboxText: {
    fontSize: 12,
    color: "#000",
  },
  checkboxContainerHorizontal: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: 7,
  },
  checkboxContainer: {
    flexDirection: "row",
    marginBottom: 10,
  },
  checked: {
    backgroundColor: "#fff",
    justifyContent: "center",
    marginR: 10,
    alignItems: "center",
    borderColor: "#000",
  },
  textarea: {
    fontSize: 12,
    borderWidth: 1,
    borderColor: "#000",
    padding: 10,
    borderRadius: 5,
    width: "100%", // Ajuste automático al ancho disponible
    minHeight: 40, // Asegura que tenga un mínimo de altura
    flexShrink: 1, // Permite que el contenedor ajuste su tamaño según el contenido
    backgroundColor: "#f0f0f0",
  },

  signatureContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
    marginBottom: 20, // Agregar separación al final de la sección
  },
  signature: {
    width: "45%",
    textAlign: "center",
  },

  interlineText: {
    marginTop: 15,
    fontSize: 12,
    textAlign: "center",
  },
  footerSpacer: {
    flexGrow: 1, // Esto empuja el contenido hacia arriba
  },
  column: {
    width: "33%", // Cada columna ocupa un tercio del ancho
    alignItems: "center", // Centra los elementos dentro de las columnas
  },
  tableCol30: {
    width: "30%",
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: "#000",
    fontSize: 12,
  },
  tableCol70: {
    width: "70%",
    padding: 5,
    textAlign: "left",
    borderRightWidth: 1,
    borderRightColor: "#000",
    fontSize: 12,
  },
  sectionTitle: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    marginTop: 15,
    marginBottom: 10,
    textAlign: "center",
  },
  normalText: {
    fontSize: 12,
  },
  sectionExclusive: {
    marginTop: 20,
    marginBottom: 10,
    padding: 10,
    borderWidth: 1,
    borderColor: "#000",
  },
  paragraph: {
    fontSize: 12,
    textAlign: "justify",
    marginBottom: 8,
    lineHeight: 1.5,
  },
  blueText: {
    color: "#0000FF",
    textDecoration: "underline",
  },
  signatureSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  signatureTitle: {
    fontWeight: "bold",
    marginRight: 10,
  },

  tableCol100: {
    width: "100%",
    padding: 5,
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
  },
  tableCol50: {
    width: "50%",
    padding: 5,
    textAlign: "left",
    borderRightWidth: 1,
    borderRightColor: "#000",
    fontSize: 12,
  },
  tableCol50_title: {
    width: "50%",
    padding: 5,
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
    borderRightWidth: 1,
    borderRightColor: "#000",
  },
  subtitleRow: {
    backgroundColor: "#f2f2f2",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  subtitleText: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },
  signatureBlock: {
    marginTop: 20,
    marginBottom: 20,
    width: "100%",
  },
  signatureHeader: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 10,
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
  },
  signatureContent: {
    marginLeft: 20,
    marginTop: 10,
  },
  signatureLine: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    width: "50%",
    marginBottom: 5,
  },
  signatureLabel: {
    fontSize: 12,
    marginTop: 5,
    marginBottom: 5,
  },
  signatureText: {
    fontSize: 12,
    marginBottom: 3,
  },
  signatureImage: {
    width: 200,
    height: 70,
  },
  // ...tus estilos existentes
  footerCodeContainer: {
    position: "absolute",
    bottom: 20,
    right: 40,
  },
  footerCode: {
    fontSize: 10,
    fontStyle: "italic",
    color: "#0D0D0D",
    fontFamily: "Times-Bold", // <-- Esta línea hace el texto en negrita
  },
});


const MyDocument = ({ formData }) => {
  if (!formData) {
    return (
      <Document>
        <Page style={styles.page}>
          <Text>No hay datos disponibles</Text>
        </Page>
      </Document>
    );
  }

  return (
    <Document>
      <Page style={styles.page}>

        <View style={styles.content}>
          <View fixed>
            <View style={styles.headerTable} fixed>
              <View style={styles.logoColumn}>
                <Image style={styles.banner} src={"Banner_membrete.png"} />
              </View>

              <View style={styles.infoColumn}>
                <View style={styles.codeRow}>
                  <Text style={styles.codeText}>CÓDIGO: IR-F-113</Text>
                </View>
                <View style={styles.dateVersionRow}>
                  <View style={styles.dateCell}>
                    <Text style={[styles.text, { fontSize: 9 }]}>FECHA: 2020-07-14</Text>
                  </View>
                  <View style={styles.versionCell}>
                    <Text style={[styles.text, { fontSize: 9 }]}>VERSIÓN: V-1</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>

          <Text style={styles.title}>REPORTE DE NOVEDADES</Text>
          <Text style={styles.text}>Convenio y/o contrato No. de 202___</Text>
          <View style={styles.infoContainer}>
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <View style={styles.tableCol100}>
                  <Text style={[styles.lastCell, { textAlign: "center" }]}>INFORMACIÓN GENERAL</Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol50}>Fecha de diligenciamiento</Text>
                <Text style={[styles.tableCol50, styles.lastCell]}>
                  {formData?.fecha_registro || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol50}>
                  Nombre completo del titular del proyecto
                </Text>
                <Text style={[styles.tableCol50, styles.lastCell]}>
                  {formData?.nombreParticipante || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol50}>Número de identificación</Text>
                <Text style={[styles.tableCol50, styles.lastCell]}>
                  {formData?.numeroIdentificacion || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol50}>Código - SIRR</Text>
                <Text style={[styles.tableCol50, styles.lastCell]}>
                  {formData?.codigoSIRR || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol50}>Nombre del proyecto</Text>
                <Text style={[styles.tableCol50, styles.lastCell]}>
                  {formData?.nombreProyecto || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol50}>Departamento</Text>
                <Text style={[styles.tableCol50, styles.lastCell]}>
                  {formData?.departamento || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol50}>Municipio</Text>
                <Text style={[styles.tableCol50, styles.lastCell]}>
                  {formData?.municipio || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol50}>Vereda</Text>
                <Text style={[styles.tableCol50, styles.lastCell]}>
                  {formData?.vereda || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol50}>Código PRE-PP</Text>
                <Text style={[styles.tableCol50, styles.lastCell]}>
                  {formData?.codigoPREPP || ""}
                </Text>
              </View>
            </View>
          </View>


          {/* Título de la descripción del proyecto */}
          <Text style={[styles.title, { marginTop: 10 }]}>Descripción del proyecto</Text>

          {/* Fila de la tabla para la descripción del proyecto */}
          <View style={styles.infoContainer}>
            <Text style={styles.textareaLabel}>
              {formData?.descripcionProyecto || ""}
            </Text>
          </View>

          {/* Título de la descripción del proyecto */}
          <Text style={styles.signatureHeader}>
            Tipo de Novedad:{" "}
            <Text style={styles.textareaLabel}>{formData?.novedad || ""}</Text>
          </Text>

          {formData?.tipoNovedad === 3 && (
            <View style={styles.infoContainer} >
              <View style={styles.table}>
                <View style={styles.tableHeader}>
                  <View style={styles.tableCol50_title}>
                    <Text style={{ textAlign: "center" }}>DATOS ANTERIORES</Text>
                  </View>
                  <View style={styles.tableCol50_title}>
                    <Text style={{ textAlign: "center" }}>
                      DATOS ACTUALIZADOS
                    </Text>
                  </View>
                </View>
                <View style={styles.tableRow}>
                  <Text style={styles.tableCol50}>Sector economico</Text>
                  <Text style={styles.tableCol50}>
                    {formData?.sector_economico || ""}
                  </Text>
                  <Text style={styles.tableCol50}>Sector economico</Text>
                  <Text style={[styles.tableCol50, styles.lastCell]}>
                    {formData?.name_sector_economico_cambio || ""}
                  </Text>
                </View>
                <View style={styles.tableRow}>
                  <Text style={styles.tableCol50}>Actividad productiva</Text>
                  <Text style={styles.tableCol50}>
                    {formData?.actividad_productiva || ""}
                  </Text>
                  <Text style={styles.tableCol50}>Actividad productiva</Text>
                  <Text style={[styles.tableCol50, styles.lastCell]}>
                    {formData?.name_actividad_productiva_cambio || ""}
                  </Text>
                </View>

                {formData?.nombreProyecto_cambio?.trim() && (
                  <View style={styles.tableRow}>
                    <Text style={styles.tableCol50}>Nombre del proyecto</Text>
                    <Text style={styles.tableCol50}>
                      {formData?.nombreProyecto || ""}
                    </Text>
                    <Text style={styles.tableCol50}>Nombre del proyecto</Text>
                    <Text style={[styles.tableCol50, styles.lastCell]}>
                      {formData?.nombreProyecto_cambio}
                    </Text>
                  </View>
                )}

                {formData?.descripcionProyecto_cambio?.trim() && (
                  <View style={styles.tableRow}>
                    <Text style={styles.tableCol50}>
                      Descripción del proyecto
                    </Text>
                    <Text style={styles.tableCol50}>
                      {formData?.descripcionProyecto || ""}
                    </Text>
                    <Text style={styles.tableCol50}>
                      Descripción del proyecto
                    </Text>
                    <Text style={[styles.tableCol50, styles.lastCell]}>
                      {formData?.descripcionProyecto_cambio}
                    </Text>
                  </View>
                )}
              </View>
            </View>
          )}

          {/* Título de la descripción del proyecto */}
          <Text style={styles.title}>Descripción de la novedad</Text>

          {/* Fila de la tabla para la descripción del proyecto */}
          <View style={styles.infoContainer}>
            <Text style={styles.textareaLabel}>
              {formData?.descripcionNovedad || ""}
            </Text>
          </View>

          <View style={styles.infoContainer}>
            <Text style={styles.textareaLabel}>
              En constancia de lo anterior, firmo la presente novedad, en el
              departamento de {formData?.departamentoNovedad || ""}
              municipio de {formData?.municipioNovedad || ""} , a los{" "}
              {formData?.diasNovedad || ""} días del mes de
              {formData?.mesNovedad || ""} de{" "}
              {formData?.anioNovedad || ""}
            </Text>
          </View>

          {/* Firma titular */}
          <View style={styles.signatureBlock} wrap={false}>
            <Text style={styles.signatureHeader}>
              PARTICIPANTE TITULAR O SUPLENTE
            </Text>
            <View style={styles.signatureContent}>
              {formData?.firmaTitular &&
                formData?.firmaTitular.trim() !== "" ? (
                <Image
                  style={styles.signatureImage}
                  src={`${baseUrl}${formData?.firmaTitular}?t=${new Date().getTime()}`}
                />
              ) : (
                <View
                  style={[
                    styles.signatureImage,
                    {
                      justifyContent: "center",
                      alignItems: "center",
                      borderWidth: 0, // Sin borde
                    },
                  ]}
                >
                  <Text style={{ color: "#888", fontSize: 12 }}>
                    {" "}
                    {/* Tamaño más pequeño */}
                    Firma no disponible
                  </Text>
                </View>
              )}

              <View style={styles.signatureLine} />
              <Text style={styles.signatureText}>
                Nombre: {formData?.nombreTitular || ""}
              </Text>
              <Text style={styles.signatureText}>
                CC: {formData?.ccTitular || ""}
              </Text>
            </View>
          </View>

          <View style={styles.signatureBlock} wrap={false}>
            <Text style={styles.signatureHeader}>FIRMA PROFESIONAL FAO</Text>
            <View style={styles.signatureContent}>
              {formData?.firmaContratista &&
                formData?.firmaContratista.trim() !== "" ? (
                <Image
                  style={styles.signatureImage}
  src={`${baseUrl}${formData?.firmaContratista}?t=${new Date().getTime()}`}
                />
              ) : (
                <View
                  style={[
                    styles.signatureImage,
                    {
                      justifyContent: "center",
                      alignItems: "center",
                      borderWidth: 0, // Sin borde
                    },
                  ]}
                >
                  <Text style={{ color: "#888", fontSize: 12 }}>
                    {" "}
                    {/* Tamaño más pequeño */}
                    Firma no disponible
                  </Text>
                </View>
              )}

              <View style={styles.signatureLine} />
              <Text style={styles.signatureText}>
                Nombre: {formData?.nombreContratista || ""}
              </Text>
              <Text style={styles.signatureText}>
                CC: {formData?.ccContratista || ""}
              </Text>
            </View>
          </View>
        </View>


        <View style={styles.footerCodeContainer}>
          <Text style={styles.footerCode}>
            Código Único: {formData?.codigo_pdf || "N/A"}
          </Text>{" "}
        </View>
      </Page>
    </Document>
  );
};

const PdfNovedad = ({ formData: initialFormData, onClose }) => {
  const [formData, setFormData] = useState(initialFormData || {});
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const fileName = `7_Novedad_${formData.id}_${formData.fecha_archivo}.pdf`;
  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-8">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-4 md:p-6 mb-8">
          {/* Título y botones */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <Title
              level={isDesktop ? 2 : 3}
              style={{ color: "#1890ff", fontWeight: "bold" }}
            >
              Reporte de novedad
            </Title>
            <Divider />
          </div>

          <div className="flex flex-col md:flex-row gap-4 mb-4">
            <Button
              type="danger"
              size={isDesktop ? "large" : "middle"}
              icon={<ArrowLeftOutlined />}
              onClick={onClose}
            >
              Volver
            </Button>

            <PDFDownloadLink
              document={<MyDocument formData={formData} />}
              fileName={fileName}
            >
              {({ loading }) => (
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  loading={loading}
                  size={isDesktop ? "large" : "middle"}
                >
                  Descargar PDF
                </Button>
              )}
            </PDFDownloadLink>
          </div>

          {/* Visor del PDF responsivo */}
          <div
            className="w-full border border-gray-300 rounded-lg"
            style={{
              height: isDesktop ? "800px" : "500px",
              overflow: "hidden",
            }}
          >
            <PDFViewer
              style={{
                width: "100%",
                height: "100%",
                border: "none", // Elimina el borde del visor
              }}
            >
              <MyDocument formData={formData} />
            </PDFViewer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfNovedad;
